import React from "react";

// plugin imports
import { useI18next } from "@herob191/gatsby-plugin-react-i18next";

// utils imports
import { findRestaurantInHref } from "../utils/restaurant";

// svg imports

export const RouteContext = React.createContext({
	location: undefined,
});

const defaultValues = {
	navMenuOpen: false,
	restaurant: undefined,
	showLogotype: false,
};

export const LayoutContext = React.createContext(defaultValues);

export const LayoutProvider = ({ children }) => {
	const [navMenuOpen, setNavMenuOpen] = React.useState(false);

	const [restaurantId, setRestaurantId] = React.useState(undefined);
	const { location } = React.useContext(RouteContext);
	React.useEffect(() => {
		setRestaurantId(findRestaurantInHref(location?.href));
	}, [location]);

	const [showNavLogotype, setShowNavLogotype] = React.useState(true);
	const screenTopMargin = 100;
	const scrollThreshold = 50;
	const prevScrollTop = React.useRef(scrollThreshold);
	const navBarHandleTimeout = React.useRef(null);
	React.useEffect(() => {
		if (typeof window !== undefined) {
			// show mobileNavMenu
			const handleScroll = () => {
				const scrollTop = window.scrollY;
				if (scrollTop > screenTopMargin && scrollTop > prevScrollTop.current) {
					setShowNavLogotype(false);
					navBarHandleTimeout.current = window.setTimeout(() => {
						prevScrollTop.current = scrollTop;
					}, 50);
				} else {
					setShowNavLogotype(!restaurantId);
					navBarHandleTimeout.current = window.setTimeout(() => {
						prevScrollTop.current = scrollTop;
					}, 50);
				}
			};

			handleScroll();
			window.addEventListener("scroll", handleScroll);

			return () => {
				window.removeEventListener("scroll", handleScroll);
			};
		}
	}, [restaurantId]);

	// Safe layout-level redirect for Gatsby + React 18 to avoid hydration mismatch
	const { language, languages, changeLanguage } = useI18next();
	React.useEffect(() => {
		const storedLang = window.localStorage.getItem("gatsby-i18next-language");
		const browserLang = window.navigator.language.split("-")[0];
		let detected = storedLang || browserLang;

		if (!languages.includes(detected)) {
			detected = "es";
		}

		if (
			detected !== language &&
			window.sessionStorage.getItem("lang-redirected") !== language
		) {
			// Prevent double prefixing (/en/en/ etc) if we are already at the target path
			if (
				window.location.pathname.startsWith(`/${detected}/`) ||
				window.location.pathname === `/${detected}`
			) {
				return;
			}

			window.sessionStorage.setItem("lang-redirected", detected);
			changeLanguage(detected);
		} else {
			window.sessionStorage.setItem("lang-redirected", language);
		}
	}, [language, languages, changeLanguage]);

	return (
		<LayoutContext.Provider
			value={{
				...defaultValues,
				navMenuOpen,
				setNavMenuOpen,
				restaurantId,
				setRestaurantId,
				showNavLogotype,
			}}
		>
			{children}
		</LayoutContext.Provider>
	);
};
